export const LOGIN = 'LOGIN';
export const LOGOUT = 'LOGOUT';
export const UPDATE_USER = 'UPDATE_USER';

export const mutations = {
  [LOGIN](state, token) {
    localStorage.setItem('accessToken', token);
    state.loggedIn = true;
  },

  [LOGOUT](state) {
    localStorage.removeItem('accessToken');
    localStorage.removeItem('userInfo');
    state.loggedIn = false;
    state.user = null;
  },

  [UPDATE_USER](state, user) {
    localStorage.setItem('userInfo', JSON.stringify(user));
    state.user = user;
  },
};
